// extracted by mini-css-extract-plugin
module.exports = {"container":"Resources_container__5dDjO","header":"Resources_header__Ex2iP","cards-container":"Resources_cards-container__2RvVX"};